import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export function createDuplicateContactsApi(getAuthHeader) {
    const config = () => ({ headers: getAuthHeader ? getAuthHeader() : {} });
    return {
        list: (params = {}) => axios.get(`${API}/contacts/duplicates`, { ...config(), params }).then((response) => response.data),
        preview: (body) => axios.post(`${API}/contacts/merge/preview`, body, config()).then((response) => response.data),
        merge: (body) => axios.post(`${API}/contacts/merge`, body, config()).then((response) => response.data),
        // The org's newest finished merges ({operations, count}); the server caps limit at 50.
        recentMerges: (params = {}) => axios.get(`${API}/contacts/merge/operations`, { ...config(), params: { limit: 20, ...params } }).then((response) => response.data),
        operation: (operationId) => axios.get(`${API}/contacts/merge/${encodeURIComponent(operationId)}`, config()).then((response) => response.data),
        undo: (operationId) => axios.post(`${API}/contacts/merge/${encodeURIComponent(operationId)}/undo`, {}, config()).then((response) => response.data),
    };
}

export default createDuplicateContactsApi;
